module.exports = __webpack_public_path__ + "static/img/mnzl-logo.692795e2.png";